import {DomainEvent} from './DomainEvent';
import {District} from '../resources/District';

export class DistrictCreated extends DomainEvent<District> {}
